import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PopupModule } from '@portal-core/ui/popup/popup.module';
import { SnackBarErrorModule } from '@portal-core/ui/snack-bar/components/snack-bar-error/snack-bar-error.module';
import { SnackBarWarningModule } from '@portal-core/ui/snack-bar/components/snack-bar-warning/snack-bar-warning.module';
import { EquationToolbarPopupPluginViewComponent } from './equation-toolbar-popup-plugin-view.component';

@NgModule({
  declarations: [
    EquationToolbarPopupPluginViewComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatTooltipModule,
    PopupModule,
    SnackBarErrorModule,
    SnackBarWarningModule
  ],
  exports: [
    EquationToolbarPopupPluginViewComponent
  ]
})
export class EquationToolbarPopupPluginViewModule { }
